import * as list from './list';
import * as optionsList from './optionsList';
import * as citiesOfCountry from './citiesOfCountry';

export default {
  ...list,
  ...optionsList,
  ...citiesOfCountry,
};
